import { createAsyncThunk } from '@reduxjs/toolkit';

import { callGetShift } from '../../helpers/api_helper';

export const searchProductAPI = createAsyncThunk(
  'ecommerce/searchProducts',
  async (params?: any) => {
    try {
      const response = callGetShift();
      return response;
    } catch (error) {
      return error;
    }
  },
);
